import { spawn } from 'redux-saga/effects';

import { watchGetLinks } from './links';

export default function* saga() {
  yield spawn(watchGetLinks);
}
